import React, { Component } from 'react';
import Landing from './Landing/';
import Regular from './Regular/';
import { Redirect } from 'react-router';
import NoMatch from 'react-router-nomatch';
import { createBrowserHistory } from 'history';


import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom';
import './App.css';

const NotFound = () => <div>NotFound</div>;


class App extends Component {
  render() {
    return (
	    <Router history={createBrowserHistory()}>
         <div className="App">
            <Route exact path="/" component={Landing}/>
            <Route exact path="/index.html"  render={() => (<Redirect to="/"/>)}/>
            <Route path="/publications/:id" component={Regular}/>
            <Route onEnter={() => window.location.reload()} />
          </div>
	     </Router>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js